import {PayloadV2} from '../../../../../core/service/payload/payloadV2';
import {Moment} from 'moment';

export class MedicalMorphologySavePayload extends PayloadV2 {
    consultationId: number;
    date: Moment;
    height: number;
    weight: number;
    shoeSize: number;
    comment: string;
    partnerId: number;
}
